export const USER_CONTEXT_KEY = "zhihao-web-user";

interface RuntimeHandlers {
    confirm: (message: string) => Promise<void>;
    error: (message: string) => void;
    hasMemberPermission: (permission: string) => boolean;
    loginExpired: () => void;
    memberLimit: (options?: { blurImg?: string[] | string }) => void;
    offline: () => void;
    success: (message: string) => void;
    tenantId: () => string;
    warning: (message: string) => void;
}

const handlers: RuntimeHandlers = {
    confirm: async () => undefined,
    error: (message) => console.error(message),
    hasMemberPermission: () => false,
    loginExpired: () => { window.location.href = window.location.protocol === "http:" ? "http://localhost:5173/login" : `${window.location.origin}/login`; },
    offline: () => { window.location.href = "/console/500"; },
    memberLimit: () => undefined,
    success: (message) => console.info(message),
    tenantId: () => "",
    warning: (message) => console.warn(message)
};

/** 请求层通过运行时回调解耦 UI、路由和后续 Zustand Store。 */
export function configureRequestRuntime(options: Partial<RuntimeHandlers>) { Object.assign(handlers, options); }
export function notifyRequestError(message: string) { handlers.error(message); }
export function notifySuccess(message: string) { handlers.success(message); }
export function notifyWarning(message: string) { handlers.warning(message); }
export function confirmAction(message: string) { return handlers.confirm(message); }
export function hasMemberPermission(permission: string) { return handlers.hasMemberPermission(permission); }
export function openMemberLimit(options?: { blurImg?: string[] | string }) { handlers.memberLimit(options); }
export function handleLoginExpired() { handlers.loginExpired(); }
export function handleOffline() { handlers.offline(); }
export function getTenantId() { return handlers.tenantId(); }

export function readToken(storage: Pick<Storage, "getItem"> = window.localStorage) {
    try { return (JSON.parse(storage.getItem(USER_CONTEXT_KEY) ?? "{}") as { zhihaoWebToken?: string }).zhihaoWebToken ?? ""; }
    catch { return ""; }
}
